module.exports = __webpack_public_path__ + "static/media/CoraMacLeod.99ca786e.jpg";